var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class, _class2, _descriptor;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

/**
 * @copyright
 * Copyright(c) 2019 SICK AG
 */

/* eslint-disable jsdoc/require-returns */
import { Component, html, Prop, Interceptor } from '@sick-davinci/ce-decorators';
import { AbstractDonut } from './AbstractDonut.js';
import { style } from './Donut.style';
/**
 * Similar to the @see Donut but with a different kind of legend.
 * Should only be used for displaying states.
 * Default palette is "state"
 * Only up to 4 values are allowed.
 *
 * @example
 * ```html
 * <davinci-element-container style="width: 300px; height: 300px">
 *   <davinci-status-donut symbols="['ok', 'nok', 'warning', 'unknown']" values="[20, 5, 12, 2]" legend-labels='["OK", "ERROR", "WARNING", "IGNORE"]'></davinci-status-donut>
 * </davinci-element-container>
 * ```
 */

export let StatusDonut = (_dec = Component({
  tag: 'davinci-status-donut',
  style
}), _dec2 = Reflect.metadata("design:paramtypes", []), _dec3 = Prop({
  reflectAsAttribute: false
}), _dec4 = Reflect.metadata("design:type", Object), _dec5 = Interceptor('values'), _dec6 = Reflect.metadata("design:paramtypes", [Object, Object]), _dec(_class = _dec2(_class = (_class2 = class StatusDonut extends AbstractDonut {
  constructor() {
    super(false);

    _initializerDefineProperty(this, "symbols", _descriptor, this);

    this.palette = 'state';

    this._computeSegmentColors();
  }
  /**
   * a list of symbols, can be less than the number of labels, will wrapped automatically
   * symbols are either @ref LegendSymbols or <svg>
   *
   * @default []
   * @example ["ok","warning","error","dontcare"]
   * @example ["ok", "<svg xmlns=\"http://www.w3.org/2000/svg\" enable-background=\"new 0 0 24 24\" height=\"24\" viewBox=\"0 0 24 24\" width=\"24\"><g><path d=\"M0,0h24v24H0V0z\" fill=\"none\"/></g><g><g><path d=\"M12,5V2L8,6l4,4V7c3.31,0,6,2.69,6,6c0,2.97-2.17,5.43-5,5.91v2.02c3.95-0.49,7-3.85,7-7.93C20,8.58,16.42,5,12,5z\"/><path d=\"M6,13c0-1.65,0.67-3.15,1.76-4.24L6.34,7.34C4.9,8.79,4,10.79,4,13c0,4.08,3.05,7.44,7,7.93v-2.02 C8.17,18.43,6,15.97,6,13z\"/></g></g></svg>"]
   */


  /**
   * Sanitation: make sure not more than 6 values are used. Max what layout can handle properly
   *
   * @param _ov - old value
   * @param nv - new value
   * @returns sanitized value
   */
  valuesWatcher(_ov, nv) {
    if (nv.length > 4) {
      // eslint-disable-next-line
      console.warn(`"davinci-status-donut" provided ${nv.values.length} values, but only defined for up to 4 values.`);
      return nv.slice(0, 4);
    }

    return nv;
  }
  /**
   * See base class
   */


  render() {
    var _this$symbols;

    if (((_this$symbols = this.symbols) === null || _this$symbols === void 0 ? void 0 : _this$symbols.length) > 0) {
      return html`
        <davinci-legend placement="N&S" symbol-size='30' .symbols=${this.symbols} symbol-positions='["left","right"]' .palette=${this.palette} .colors=${this.colors} .labels=${this.legendLabels || []}>
        ${this._createSVG()}
        </davinci-legend>`;
    } else {
      return this._createSVG();
    }
  }

}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "symbols", [_dec3, _dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _applyDecoratedDescriptor(_class2.prototype, "valuesWatcher", [_dec5, _dec6], Object.getOwnPropertyDescriptor(_class2.prototype, "valuesWatcher"), _class2.prototype)), _class2)) || _class) || _class);
